import React from 'react';
import { INVOICE_SIGNATURE_LABELS } from '../constants/invoice';

function InvoiceSignatures({ fontSize = 10 }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '18px',
        marginTop: '18mm',
        pageBreakInside: 'avoid',
      }}
    >
      {INVOICE_SIGNATURE_LABELS.map((label) => (
        <div key={label} style={{ textAlign: 'center', fontSize }}>
          <div style={{ borderTop: '1px solid #000', paddingTop: '6px' }}>{label}</div>
        </div>
      ))}
    </div>
  );
}

export default InvoiceSignatures;
